// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__SDbxB","title":"Info_title__1eMDM","links":"Info_links__DmU51","link":"Info_link__9tpUe","logo":"Info_logo__13APa"};